import { SpinButton, Stack, StackItem } from "@fluentui/react";
import {  Body1, Button, Divider, Body1Strong, Body2, Combobox, ComboboxProps, useComboboxFilter, useId, Badge, Input, Spinner, } from "@fluentui/react-components";
import moment from 'moment';
import { useContext, useEffect, useState } from 'react';
import { GlobalContext } from "../../hooks/globalContext";
import apiCall from "../../utility/api";
import { popularTimezones } from "../../utility/utils";

interface UserData {
	firstName?: string;
	lastName?: string;
	timezone?: string;
	formData?: any;
	firstNameError?: string,
	lastNameError?: string,
	timezoneError?: string,
}

// Define the props interface for the profileDrawer component
interface ProfileDrawerProps {
    userData: UserData;
    userRole: string;
    userEmail: string;
    errorMessage?: string;
    setUserData: any
    utcZone: string;
    firstName: string;
    setQuery: any;
    lastName:string;
    userDetailsFromLocalStorage: any;
    setErrorMessage: any;
    setOverlayOpen: any;
  }

export const ProfileDrawer: React.FC<ProfileDrawerProps> = ({
  userData,
  userRole,
  userEmail,
  errorMessage,
  setQuery,
  utcZone,
  firstName,
  lastName,
  setUserData,
  userDetailsFromLocalStorage,
  setErrorMessage,
  setOverlayOpen
}) => {
    const [isEditing, setIsEditing] = useState(false);
    const comboId = useId();
	const beforeId = useId("content-before");
    const contextValue: any = useContext(GlobalContext);
	const [isSubmit,setIsSubmit] = useState(false);
    // const options = moment.tz.names().map((tz) => ({
	// 	children: tz,
	// 	value: tz,
	// }));
console.log("initial userData: " + JSON.stringify( userData));
	

	const options = popularTimezones.map((tz) => {
		const offset = moment.tz(tz).utcOffset() / 60;
		const offsetLabel = `(GMT${offset >= 0 ? '+' : ''}${offset}:00)`;
		return {
			children: `${offsetLabel} ${tz}`, // This is how it will appear in the dropdown
			value: tz,
		};
	});
	
    const children = useComboboxFilter(userData?.timezone ?? '', options, { noOptionsMessage: "No time zone matched your search." });
	useEffect(() => {
		console.log("userData in profile: " + JSON.stringify(userData));
		console.log("userDetailsFromLocalStorage in profile: " + JSON.stringify(userDetailsFromLocalStorage));
	}, [userData])
	

    const handleFirstNameChange = (e: any) => {
		let fName = e.target.value;
		setUserData((prevState: any) => ({ ...prevState, firstName: fName, firstNameError: '' }));
	};

	const handleLastNameChange = (e: any) => {
		let lName = e.target.value;
		setUserData((prevState: any) => ({ ...prevState, lastName: lName, lastNameError: '' }));
	};

	const handleTimezoneChange = (selectedOption: any) => {
		console.log('options----', selectedOption.target.value);
		setUserData((prevState: any) => ({ ...prevState, timezone: selectedOption.target.value, timezoneError: '' }));
	};

	const validateFirstName = (value: any) => {
		if (value.trim().length === 0) {
			return 'First name is required.';
		}
		return ''; // No error
	};

	const validateLastName = (value: any) => {
		if (value.trim().length === 0) {
			return 'Last name is required.';
		}
		return ''; // No error
	};

	const validateTimezone = (value: any) => {
		if (!value) {
			return 'Please select a timezone.';
		}
		return ''; // No error
	};


    const onOptionSelect: ComboboxProps["onOptionSelect"] = (e: any, data: any) => {
		setQuery(data.optionText ?? "");
		setUserData({ ...userData, timezone: data.optionText });
		setIsEditing(false);
	};

    const handleClearSelection = () => {
		setUserData({ ...userData, timezone: "" });
	};

    // const handleUserDetailsChangeSubmit = async (event: any) => {
	// 	event.preventDefault();

	// 	const firstNameError = validateFirstName(userData.firstName);
	// 	const lastNameError = validateLastName(userData.lastName);
	// 	const timezoneError = validateTimezone(userData.timezone);
	// 	let lname: any = '', fname: any = '', newTimeZone: any = ''
	// 	// Update state with validation errors
	// 	setUserData({
	// 		...userData,
	// 		firstNameError,
	// 		lastNameError,
	// 		timezoneError,
	// 	});

	// 	if (!firstNameError && !lastNameError && !timezoneError) {
	// 		var timeZoneValue, firstNameValue, lastNameValue;
	// 		if (userData.timezone !== utcZone) {
	// 			newTimeZone = 'Timezone';
	// 			timeZoneValue = userData.timezone
	// 			userData.formData.TimeZone = userData.timezone;
	// 		}
	// 		if (userData.firstName !== firstName) {
	// 			fname = 'First Name';
	// 			userData.formData.firstName = userData.firstName;
	// 			firstNameValue = userData.firstName;
	// 			contextValue.setUserSessionDetails({
	// 				...contextValue.userSessionDetails,
	// 				userName: firstNameValue,
	// 			})
	// 			userDetailsFromLocalStorage.firstName = firstNameValue;
	// 		}
	// 		if (userData.lastName !== lastName) {
	// 			lname = 'Last Name';
	// 			userData.formData.lastName = userData.lastName;
	// 			lastNameValue = userData.lastName;
	// 			console.log("userData=", userData);
	// 			console.log("lastNameValue=", lastNameValue);
	// 			contextValue.setUserSessionDetails({
	// 				...contextValue.userSessionDetails,
	// 				userLName: lastNameValue,
	// 			})
	// 			userDetailsFromLocalStorage.lastName = lastNameValue;
	// 		}
	// 		// Form is valid, submit data (e.g., send to server)

	// 		let formDataEdit = JSON.stringify(userData.formData);
	// 		let userid = contextValue.userSessionDetails.userId
	// 		contextValue.setUserSessionDetails({
	// 			...contextValue.userSessionDetails,
	// 			otherDetails: formDataEdit,
	// 			userLName: lastName,
	// 			userName: firstName,

	// 		})
	// 		userDetailsFromLocalStorage.formDataEdit = formDataEdit;
	// 		localStorage.setItem('userDetails', JSON.stringify(userDetailsFromLocalStorage));
	// 		sessionStorage.setItem('userDetails', JSON.stringify(userDetailsFromLocalStorage));
	// 		// Add your logic to send data to the server here
	// 		const whereCondition = { firstName: firstNameValue, lastName: lastNameValue, timezone: timeZoneValue, formDataEdit: formDataEdit }
	// 		try {
	// 			console.log('profile whereCondition: ' + whereCondition);
	// 			setErrorMessage('')
	// 			let { data,status } = await apiCall('/users/updateUserProfile', { userid, ...whereCondition });

	// 			if (status == "success") {
	// 				console.log("rows affected for Updated Users from db:", data.affected_rows);
	// 				setErrorMessage('User details updated successfully!')
	// 				setTimeout(() => {
	// 					setErrorMessage('')
	// 					setOverlayOpen(false);
	// 				}, 2000);
	// 			} else {
	// 				setErrorMessage('Oops! Something went wrong.')
	// 			}
	// 		} catch (error) {
	// 			console.error("An unexpected error occurred:", (error as Error).message);
	// 			setErrorMessage('Oops! Something went wrong.')
	// 			// Handle unexpected errors, log them, and potentially notify the user
	// 		}
	// 	}
	// };

	const handleUserDetailsChangeSubmit = async (event: any) => {
		event.preventDefault();
	    setIsSubmit(true);
		const firstNameError = validateFirstName(userData.firstName);
		const lastNameError = validateLastName(userData.lastName);
		const timezoneError = validateTimezone(userData.timezone);
	
		// Update state with validation errors
		setUserData({
			...userData,
			firstNameError,
			lastNameError,
			timezoneError,
		});
	
		if (!firstNameError && !lastNameError && !timezoneError) {
			// Parse existing form data from local storage
			let existingFormData = {};
			try {
				if (userDetailsFromLocalStorage.formDataEdit) {
					existingFormData = JSON.parse(userDetailsFromLocalStorage.formDataEdit);
				}
			} catch (parseError) {
				console.error("Error parsing existing form data:", parseError);
			}
	
			// Create a copy of existing form data and update with new values
			const updatedFormData:any = { ...existingFormData };
			
			let shouldUpdateTimezone = false;
			let shouldUpdateFirstName = false;
			let shouldUpdateLastName = false;
	
			// Check and update timezone
			if (userData.timezone !== utcZone) {
				updatedFormData.TimeZone = userData.timezone;
				shouldUpdateTimezone = true;
				userDetailsFromLocalStorage.timezone = userData.timezone;
			}
	
			// Check and update first name
			if (userData.firstName !== firstName) {
				updatedFormData.firstName = userData.firstName;
				shouldUpdateFirstName = true;
				contextValue.setUserSessionDetails({
					...contextValue.userSessionDetails,
					userName: userData.firstName,
				});
				userDetailsFromLocalStorage.firstName = userData.firstName;
			}
	
			// Check and update last name
			if (userData.lastName !== lastName) {
				updatedFormData.lastName = userData.lastName;
				shouldUpdateLastName = true;
				contextValue.setUserSessionDetails({
					...contextValue.userSessionDetails,
					userLName: userData.lastName,
				});
				userDetailsFromLocalStorage.lastName = userData.lastName;
			}
	
			// Stringify the updated form data
			let formDataEdit = JSON.stringify(updatedFormData);
	
			// Update user session details
			contextValue.setUserSessionDetails({
				...contextValue.userSessionDetails,
				otherDetails: formDataEdit,
				userLName: userData.lastName,
				userName: userData.firstName,
			});
	
			// Update local storage
			userDetailsFromLocalStorage.formDataEdit = formDataEdit;
			localStorage.setItem('userDetails', JSON.stringify(userDetailsFromLocalStorage));
			sessionStorage.setItem('userDetails', JSON.stringify(userDetailsFromLocalStorage));
	
			// Prepare where condition for API call
			const whereCondition = { 
				...(shouldUpdateFirstName && { firstName: userData.firstName }),
				...(shouldUpdateLastName && { lastName: userData.lastName }),
				...(shouldUpdateTimezone && { timezone: userData.timezone }),
				formDataEdit: formDataEdit 
			};
	
			try {
				setErrorMessage('');
				let userid = contextValue.userSessionDetails.userId;
				let { data, status } = await apiCall('/users/updateUserProfile', { userid, ...whereCondition });
	
				if (status == "success") {
					setErrorMessage('Profile updated successfully.');
					setIsSubmit(false);
					 shouldUpdateTimezone = false;
					 shouldUpdateFirstName = false;
					 shouldUpdateLastName = false;
					setTimeout(() => {
						setErrorMessage('');
						setOverlayOpen(false);
						// window.location.reload();
					}, 2000);
				} else {
					setIsSubmit(false);
					setErrorMessage('Oops! Something went wrong.');
				}
			} catch (error) {
				console.error("An unexpected error occurred:", (error as Error).message);
				setErrorMessage('Oops! Something went wrong.');
				setIsSubmit(false);
			}
		}
	};
  return (
    <Stack tokens={{ childrenGap: 40, padding: 20 }} horizontalAlign="space-between">
			{/* {usernameAvatar()} */}
			<Stack tokens={{ childrenGap: 10 }}>
				{/* {userProfile.map((item, index) => ( */}
				<>
					<Stack horizontal horizontalAlign="space-between" tokens={{ childrenGap: 10, padding: 10 }}>
						<Body1Strong> First Name*: </Body1Strong>
						<Input size='small' onChange={(e) => handleFirstNameChange(e)} className="classfication_textarea" name="filter" value={userData.firstName} id={beforeId} />
					</Stack>
					<Divider />
					<Stack horizontal horizontalAlign="space-between" tokens={{ childrenGap: 10, padding: 10 }}>
						<Body1Strong> Last Name*: </Body1Strong>
						<Input size='small' onChange={(e) => handleLastNameChange(e)} className="classfication_textarea" name="filter" value={userData.lastName} id={beforeId} />
					</Stack>
					<Divider />
					<Stack horizontal horizontalAlign="space-between" tokens={{ childrenGap: 20, padding: 10 }}>

						<StackItem grow><Body1Strong> Time zone*: </Body1Strong></StackItem>

						<StackItem shrink>
							<Combobox
								size="small"
								id = "timeZoneDropDown"
								onOptionSelect={onOptionSelect}
								aria-labelledby={comboId}
								placeholder="Select a timezone"
								onChange={(ev) => handleTimezoneChange(ev)}
								onClick={handleClearSelection}
								value={userData.timezone}
								// clearable={true}
							// style={{width: '200px'}}
							>
								{children}
							</Combobox>
						</StackItem>
					</Stack>
					<Divider />
				</>
				{/* ))} */}
				<Stack horizontal horizontalAlign="space-between" tokens={{ childrenGap: 10, padding: 10 }}>
					<Body1Strong>Role:</Body1Strong>
					<Body1>{userRole}</Body1>
				</Stack>
				<Divider />
				<Stack horizontal horizontalAlign="space-between" tokens={{ childrenGap: 10, padding: 10 }}>
					<Body1Strong>Email:</Body1Strong>
					<Body1>{userEmail}</Body1>
				</Stack>
				<Divider />
			</Stack>
			<Stack horizontal verticalAlign="center" tokens={{childrenGap:10}}>
			<Stack horizontal>
				<Button shape="circular"type="submit" disabled={isSubmit} appearance="primary" onClick={(e) => handleUserDetailsChangeSubmit(e)}> Update Profile</Button>
			</Stack>
			{isSubmit?<Spinner delay={0} size="extra-tiny" />: ''}
			{userData.firstNameError||userData.lastNameError||userData.timezoneError||errorMessage&&<Stack horizontal horizontalAlign="center" >
				{userData.firstNameError && (<Badge appearance="ghost" color="danger"> <Body2> {userData.firstNameError} </Body2> </Badge>)}
				{userData.lastNameError && (<Badge appearance="ghost" color="danger"> <Body2> {userData.lastNameError} </Body2> </Badge>)}
				{userData.timezoneError && (<Badge appearance="ghost" color="danger"> <Body2> {userData.timezoneError} </Body2> </Badge>)}
				{errorMessage && (<Badge appearance="ghost" color="success"> <Body2> {errorMessage} </Body2> </Badge>)}
			</Stack>}
			</Stack>
		</Stack>
  )
}
